import { icon } from '../../components/icons';
import { $, $$, supportsIntersectionObserver } from '../../lib/dom';
import { trackObserver } from '../router/page-lifecycle';

/** Quote marquee on /customers: user pause/play toggle, and paused while off-screen. */
export function initMarquee(root: HTMLElement): void {
  $$('[data-marquee]', root).forEach((marquee) => {
    const toggle = $('[data-mq-toggle]', root);
    toggle?.addEventListener('click', () => {
      const paused = marquee.classList.toggle('paused-user');
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.innerHTML = paused ? `${icon('play')}<span>Play</span>` : `${icon('pause')}<span>Pause</span>`;
    });
    if (supportsIntersectionObserver()) {
      trackObserver(
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => marquee.classList.toggle('offscreen', !entry.isIntersecting));
        }),
      ).observe(marquee);
    }
  });
}
